import { useCallback, useRef, useState } from "react";

/*
 * useDragPanel — macht ein schwebendes Panel (z. B. den Ordner-Browser)
 * mit der Maus verschiebbar. Der Kopfbereich dient als Griff.
 *
 * const { dragOffset, onDragStart } = useDragPanel();
 * <div style={{ transform: `translate(${dragOffset.x}px, ${dragOffset.y}px)` }}>
 *   <div onMouseDown={onDragStart} style={{ cursor: "move" }}>Titel…</div>
 * </div>
 *
 * Die Position bleibt erhalten, bis die Seite verlassen wird.
 */
export default function useDragPanel() {
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const offsetRef = useRef({ x: 0, y: 0 });

  const onDragStart = useCallback((e) => {
    if (e.button !== 0) return;               // nur linke Maustaste
    if (e.target.closest("button, input, select, textarea, a")) return; // Klicks auf Controls nicht kapern
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const base = { ...offsetRef.current };
    const onMove = (ev) => {
      const next = { x: base.x + (ev.clientX - startX), y: base.y + (ev.clientY - startY) };
      offsetRef.current = next;
      setDragOffset(next);
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  }, []);

  return { dragOffset, onDragStart };
}
